import React, { useEffect, useState, useContext } from "react";
import _ from "lodash";
import axios from "axios";
import moment from "moment";
import FileDownload from "js-file-download";
import Utils from "./../../common/Utils";
import { Row, Col, Button, Form, Alert, Card, Table, ButtonGroup, Modal, ProgressBar, Badge } from "react-bootstrap";
import ReportBar from "./reportsBar";
import { UserContext } from "../../common";

export const options = {
  is3D: true,
  sliceVisibilityThreshold: 0,
  legend: { position: "none" },
  colors: ["#090d57", "#77d773", "#ffbe00", "#848484", "#1f9656"],
};

const assignedDays = () => _.get(Utils.getUserData(),'assigndays',180);

const Reports = () => {
  const [loading, setLoading] = useState(false);
  const [stats, setStats] = useState({ jobs: false, tasks: false, attendance: false, holidays: false });
  const [teamMembers, setTeamMembers] = useState([]);
  const [isSuperUser, setIsSuperUser] = useState(false);
  const [hasReports, setHasReports] = useState(false);
  const [listData, setListData] = useState({ label: "", data: [], loading: false, show: false });
  const [jCats, setJCats] = useState([]);
  const {userData} = useContext(UserContext);
  const [filter, setFilter] = useState(() => ({
    tab: "jobs",
    jcat: "",
    user: (userData && (userData.uid || userData.id)) || "",
    branch: "",
    jobmode: "recent",
    fromDt: moment().startOf('year').toDate(),
    toDt: moment().toDate(),
  }));

  const fetchJCats = () => {
    setLoading(true);
    axios
      .get(Utils.apiUrl("jobs/jobcategories"), Utils.apiHeaders())
      .then((res) => {
        if (res.data.success) {
          setJCats(res.data.data);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  };
  useEffect(fetchJCats, []);

  const isReportVisible = (tab = false) => {
    if (!tab) tab = _.get(filter, "tab", "jobs");
    return (
      (tab === "jobs" && parseInt(_.get(stats, "jobs.total_jobs", 0)) > 0) ||
      (tab === "tasks" && parseInt(_.get(stats, "tasks.total_tasks", 0)) > 0) ||
      (tab === "attendance" && parseInt(_.get(stats, "attendance.users", 0)) > 0) ||
      (tab === "holidays" && parseInt(_.get(stats, "holidays.total_users", 0)) > 0)
    );
  };

  const getReportFromData = (listmode) => {
    let formData = new FormData();

    if (filter.fromDt != "" && moment(filter.fromDt).isValid()) {
      formData.set("dt_from", moment(filter.fromDt).format("YYYY-MM-DD"));
    }

    if (filter.toDt != "" && moment(filter.toDt).isValid()) {
      formData.set("dt_to", moment(filter.toDt).format("YYYY-MM-DD"));
    }

    if (filter.tab === "jobs") {
      formData.set("jobmode", filter.jobmode);
    }

    formData.set("tab", filter.tab);
    formData.set("user_id", filter.user);
    formData.set("branch_id", filter.branch);
    if (listmode) {
      formData.set("listmode", listmode);
    }

    return formData;
  };

  const fetchReportStats = () => {
    setListData((prev) => ({ ...prev, show: false }));
    setLoading(true);
    axios
      .post(Utils.apiUrl("reports/status"), getReportFromData(), Utils.apiHeaders())
      .then((res) => {
        const data = Utils.parseApiResponse(res);
        if (data.success) {
          setStats((prev) => {
            if (filter.tab === "jobs") {
              return { ...prev, jobs: data.status };
            }
            if (filter.tab === "tasks") {
              return { ...prev, tasks: data.status };
            }
            if (filter.tab === "attendance") {
              return { ...prev, attendance: data.status };
            }
            if (filter.tab === "holidays") {
              return { ...prev, holidays: data.status };
            }
            return prev;
          });
        } else {
          window.alert(data.message);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchReportStats();
  }, [filter.tab, filter.user, filter.branch, filter.jobmode, filter.fromDt, filter.toDt]);

  const fetchReportListing = ({ listmode, label }) => {
    setListData({ ...listData, loading: true, show: true, listmode: listmode, label: label });
    axios
      .post(Utils.apiUrl("reports/listing"), getReportFromData(listmode), Utils.apiHeaders())
      .then((res) => {
        if (res.data.success) {
          setListData({ ...listData, loading: false, data: res.data.data, show: true, label: label });
        } else {
          window.alert(res.data.message);
          setListData({ ...listData, loading: false, show: true, label: label });
        }
      })
      .catch((err) => {
        setListData({ ...listData, loading: false, show: true, label: label });
        console.log(err);
      });
  };

  const fetchTeamMembers = () => {
    setLoading(true);
    axios
      .get(Utils.apiUrl("reports/fetchmembers"), Utils.apiHeaders())
      .then((res) => {
        if (res.data.success) {
          const members = _.get(res, "data.teamMembers", []);
          const isSuper = Boolean(_.get(res, "data.is_super_user", false));
          const hasRep = Boolean(_.get(res, "data.has_reports", false));
          setIsSuperUser(isSuper);
          setHasReports(hasRep);
          setTeamMembers(members);
          setFilter((prev) => {
            const selfMember = members.find((m) => m.is_self) || members[0];
            // If normal user without reports, strictly force to self
            if (!isSuper && !hasRep) {
              return { ...prev, user: selfMember ? selfMember.id : "" };
            }
            if (!prev.user && members.length > 0) {
              return { ...prev, user: selfMember ? selfMember.id : "" };
            }
            return prev;
          });
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => setLoading(false));
  };
  useEffect(fetchTeamMembers, []);

  const exportReport = (e) => {
    const frm = e.currentTarget;
    e.preventDefault();

    let formData = new FormData(frm);

    if (filter.fromDt != "" && moment(filter.fromDt).isValid()) {
      formData.set("dt_from", moment(filter.fromDt).format("YYYY-MM-DD 00:00:00"));
    }

    if (filter.toDt != "" && moment(filter.toDt).isValid()) {
      formData.set("dt_to", moment(filter.toDt).format("YYYY-MM-DD 23:59:59"));
    }

    setLoading(true);
    axios
      .post(Utils.apiUrl("reports/download"), formData, Utils.apiHeaders())
      .then((res) => {
        setLoading(false);
        const resData = Utils.parseApiResponse(res);
        if (resData.success && Array.isArray(resData.data) && resData.data.length > 0) {
          const rawData = resData.data;
          
          // Check if rawData is a pre-formatted multi-section report (e.g. single-user report with metadata header)
          const isPreformattedReport = Array.isArray(rawData[0]) && rawData[0].length === 1 && String(rawData[0][0]).includes("Report");

          if (isPreformattedReport) {
            const escapeCell = (cell) => {
              if (cell === null || cell === undefined) return '""';
              const str = String(cell).replace(/"/g, '""');
              return `"${str}"`;
            };
            const csvLines = rawData.map(row => Array.isArray(row) ? row.map(escapeCell).join(",") : escapeCell(row));
            const csvContent = "\uFEFF" + csvLines.join("\r\n");
            const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
            const finalFilename = `${filter.tab}_user_report_${moment().format("YYYY-MM-DD")}.csv`;

            const link = document.createElement("a");
            const url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", finalFilename);
            link.style.visibility = "hidden";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
          } else {
            const headers = Array.isArray(rawData[0]) ? rawData[0] : rawData[0].split(",");
            const rows = rawData.slice(1).map(r => Array.isArray(r) ? r : r.split(","));
            
            Utils.exportStyledCsv({
              title: `${_.capitalize(filter.tab)} Operations Report`,
              headers: headers,
              rows: rows,
              filename: `${filter.tab}_report_${moment().format("YYYY-MM-DD")}.csv`
            });
          }
        } else if (resData.success) {
          window.alert("No report records found for the selected date range.");
        } else {
          window.alert(resData.message || "Failed to download report");
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });

    return false;
  };

  const showJobsReport = () => {
    return (
      <ReportBar
        key="jobs-report"
        bardata={[
          ["Status", "Number of Jobs",false],
          ["TOTAL ASSIGNED", Math.max(0, Number(stats.jobs.total_assigned || 0)),false],
          ["COMPLETED", Math.max(0, Number(stats.jobs.completed_total || 0)),true],
          ["PENDING", Math.max(0, Number(stats.jobs.pending_total || 0)),true],
          ["MARKED NA", Math.max(0, Number(stats.jobs.na_total || 0)),true],
          ["Required Evidence", Math.max(0, Number(stats.jobs.total_rev || 0)),false],
        ]}
        options={options}
        clickData={["total_assigned", "completed_total", "pending_total", "na_total"]}
        onClick={fetchReportListing}
      />
    );
  };

  const showTasksReport = () => {
    return (
      <ReportBar
        key="tasks-report"
        bardata={[
          ["Status", "Number of Tasks",false],
          ["TOTAL ASSIGNED", Math.max(0, Number(stats.tasks.total_assigned || 0)),false],
          ["COMPLETED", Math.max(0, Number(stats.tasks.completed_total || 0)),true],
          ["OVERDUE/PENDING", Math.max(0, Number(stats.tasks.pending_total || 0)),true],
          ["MARKED NA", Math.max(0, Number(stats.tasks.na_total || 0)),true],
        ]}
        options={options}
        clickData={["total_assigned", "completed_total", "pending_total", "na_total"]}
        onClick={fetchReportListing}
      />
    );
  };

  const showAttnReport = () => {
    return (
      <ReportBar
        key="attendance-report"
        bardata={[
          ["Status", "Attendance",false],
          ["TOTAL HOURS", Math.max(0, Number(stats.attendance.ontime || 0)) + Math.max(0, Number(stats.attendance.differed || 0)),false],
          ["ONTIME", Math.max(0, Number(stats.attendance.ontime || 0)),true],
          ["DIFFERED TIME", Math.max(0, Number(stats.attendance.differed || 0)),true],
          ["PAYROLL HOURS", stats.attendance.payroll,false],
        ]}
        options={{...options,colors: ["#070d59","#77d773","#c20000","#848484"]}}
        clickData={["total", "ontime", "differed"]}
        onClick={fetchReportListing}
      />
    );
  };

  const showHolidaysReport = () => {

    
    let colors = ["#090d57"], clickdata = ["total"];
    let totalhrs = Math.max(0,Number(stats.holidays.approved || 0))+Math.max(0, Number(stats.holidays.unpaid || 0))+Math.max(0, Number(stats.holidays.pending || 0));
    let bardata = [["Status", "Number of Holidays",false]];

    if(filter.user != '' && parseInt(filter.user) > 0){
      //colors=[...colors,"#5893d4"];
      //clickdata = ['available'];
      //bardata=[...bardata,["TOTAL", totalhrs,false],["AVAILABLE", Math.max(0, Number(stats.holidays.available || 0)),false]];
      bardata=[...bardata,["TOTAL", totalhrs,false]];
    }else{
      bardata=[...bardata,["TOTAL", totalhrs,false]];
    }

    colors=[...colors,"#77d773","#c20000","#ffbf00"];
    clickdata=[...clickdata,"approved", "unpaid", "pending"];

    bardata=[...bardata,
      ["APPROVED", Math.max(0, Number(stats.holidays.approved || 0)),true],
      ["UNPAID", Math.max(0, Number(stats.holidays.unpaid || 0)),true],
      ["PENDING", Math.max(0, Number(stats.holidays.pending || 0)),true],
    ];
//console.log(bardata,colors,clickdata);
    if(totalhrs === 0){
      return <Alert variant="warning" className="my-3 p-3 text-center">No Stats found!</Alert>;
    }
    return (
      <ReportBar
        key="holidays-report"
        bardata={bardata}
        options={{...options,colors: colors}}
        clickData={clickdata}
        onClick={fetchReportListing}
      />
    );
  };

  const prepareListData = () => {
    let data = [];
    if (parseInt(_.get(listData, "data.length", 0)) > 0) {
      if (parseInt(filter.user) > 0) {
        data = listData.data.slice(8);
      } else {
        data = listData.data;
      }
    }
    return data;
  };

  const renderReportListModal = () => {
    return (
      <Modal
        size="fullscreen"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={true}
        onHide={() => setListData({ ...listData, show: false })}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {filter.tab.toUpperCase()} - {listData.label}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {renderReportList()}
        </Modal.Body>
      </Modal>
    );
  };

  const renderReportList = () => {
    return <>
      <div className="text-end muted">*only first 50 records</div>
          {listData.loading && (
            <Alert variant="info" className="p-3">
              <p className="loading-msg">Fetching Reports data..</p>
              <ProgressBar variant="info" animated now={100} />
            </Alert>
          )}
          {!listData.loading && (
            <>
              {listData.data.length === 0 && (
                <Alert variant="warning" className="p-3">
                  <b>No Records Found!</b>
                </Alert>
              )}
              {prepareListData().length > 0 && <Table striped={true} bordered={true} cellSpacing={2}>
                <thead>
                  <tr><th>Sl.</th>
                  {prepareListData()[0].map(label =><th>{label}</th>)}  
                  </tr>
                </thead>
                <tbody>
                {prepareListData().map((rec, idx1) => (
                  <tr key={idx1}>
                    {idx1 > 0  &&<td><Badge className="bg-info text-dark">{idx1}</Badge></td>}
                    {idx1 > 0 && rec.map((r, idx2) => <td key={idx2}>
                        <div style={{ maxWidth: 350 }}>{r}</div>
                      </td>)}
                  </tr>
                ))}
                </tbody>
              </Table>}
            </>
          )}
    </>;
  };

  const reportList = (showlist) => {
    
    if(showlist){
      fetchReportListing(filter.tab=='holidays' ? 
        {label: "TOTAL APPLIED", listmode: "total"} : 
        filter.tab=='attendance' ? {label: "TOTAL ATTENDANCE", listmode: "total"}
        : {label: "TOTAL ASSIGNED", listmode: "total_assigned"});
    }else{
      setListData({ ...listData, show: false });
    }
  };

  const getAllMembers = () => {
    if (filter.branch != "") {
      return _.filter(teamMembers, (m) => parseInt(m.branch_id) == parseInt(filter.branch));
    }
    return teamMembers;
  }

  const switchTab = (tab) => {
    if (!tab || tab === filter.tab) {
      return;
    }
    setLoading(true);
    setListData((prev) => ({ ...prev, show: false }));
    setFilter({ ...filter, tab });
  };

  const reportTabs = ["jobs", "tasks", "attendance", "holidays"];

  return (
    <>
      <div className="mt-4">
        <div className="nav nav-tabs report-tabs nav-fill">
          {reportTabs.map((tab) => (
            <button
              key={tab}
              type="button"
              className={`nav-link ${filter.tab === tab ? "active" : ""}`}
              onClick={() => switchTab(tab)}
            >
              {_.upperFirst(tab)}
            </button>
          ))}
        </div>
            <Row>
              <Col>
                <Card border="light" className="report-box shadow-sm table-section p-3 border-0 bottomRoundedBox mx-0">
                  <Card.Body>
                    <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3 pb-2 border-bottom">
                      <div>
                        <h2 className="dt-card__title m-0" style={{ fontSize: "20px" }}>
                          {_.upperFirst(filter.tab)} Reports
                        </h2>
                        <span className="text-muted" style={{ fontSize: "12px" }}>
                          Analyze practice performance, branch operations and compliance overview
                        </span>
                      </div>
                      <div className="d-flex align-items-center gap-2 flex-wrap">
                        {isSuperUser && _.compact(_.uniqBy(_.map(teamMembers, (member) => _.pick(member,['branch_id','branch'])),'branch_id')).filter(b => b.branch_id && b.branch).length > 0 && (
                          <select
                            className="form-select filters py-1 px-3"
                            style={{ minWidth: 160, fontSize: "13px" }}
                            value={filter.branch}
                            onChange={(e) => setFilter({ ...filter, branch: e.currentTarget.value })}
                          >
                            <option value="">All Branches</option>
                            {_.compact(_.uniqBy(_.map(teamMembers, (member) => _.pick(member,['branch_id','branch'])),'branch_id'))
                              .filter(b => b.branch_id && b.branch)
                              .map(b => <option key={b.branch_id} value={b.branch_id}>{b.branch}</option>)}
                          </select>
                        )}
                        {filter.tab === "jobs" && (
                          <select
                            className="form-select filters py-1 px-3"
                            style={{ minWidth: 140, fontSize: "13px" }}
                            value={filter.jobmode}
                            onChange={(e) => setFilter({ ...filter, jobmode: e.currentTarget.value })}
                          >
                            <option value="recent">Recent Jobs</option>
                            <option value="archived">Archived Jobs</option>
                          </select>
                        )}
                      </div>
                    </div>

                    <Row className="g-3 mb-3">
                      <Col xs={12} sm={6}>
                        <Form.Label className="small fw-bold text-muted mb-1">
                          Select Team Member:
                        </Form.Label>
                        <select
                          className="form-select filters"
                          value={filter.user}
                          disabled={!isSuperUser && !hasReports && getAllMembers().length <= 1}
                          onChange={(e) =>
                            setFilter({
                              ...filter,
                              user: e.currentTarget.value,
                            })
                          }
                        >
                          {isSuperUser && (
                            <option value="">All Members (Consolidated)</option>
                          )}
                          {hasReports && (
                            <option value="">My Team (Consolidated)</option>
                          )}
                          {getAllMembers().map((tm) => (
                            <option key={tm.id} value={tm.id}>
                              {tm.title ? `${tm.title} ` : ""}{tm.name}
                            </option>
                          ))}
                        </select>
                      </Col>

                      <Col xs={12} sm={6}>
                        <Form.Label className="small fw-bold text-muted mb-1">Select Dates:</Form.Label>
                        <div className="d-flex align-items-center gap-2">
                          <input
                            type="date"
                            className="form-control filters"
                            value={moment(filter.fromDt).format("YYYY-MM-DD")}
                            min={filter.tab === "jobs" && filter.jobmode === "recent" ? moment().add(-assignedDays(), "days").format("YYYY-MM-DD") : undefined}
                            max={filter.tab === "jobs" && filter.jobmode === "archived" ? moment().add(-assignedDays(), "days").format("YYYY-MM-DD") : filter.tab === "jobs" ? moment().format("YYYY-MM-DD") : undefined}
                            onChange={(e) => setFilter({ ...filter, fromDt: moment(e.target.value).toDate() })}
                          />
                          <span className="text-muted small">to</span>
                          <input
                            type="date"
                            className="form-control filters"
                            value={moment(filter.toDt).format("YYYY-MM-DD")}
                            min={filter.tab === "jobs" && filter.jobmode === "recent" ? moment().add(-assignedDays(), "days").format("YYYY-MM-DD") : undefined}
                            max={filter.tab === "jobs" && filter.jobmode === "archived" ? moment().add(-assignedDays(), "days").format("YYYY-MM-DD") : filter.tab === "jobs" ? moment().format("YYYY-MM-DD") : undefined}
                            onChange={(e) => setFilter({ ...filter, toDt: moment(e.target.value).toDate() })}
                          />
                        </div>
                      </Col>
                    </Row>
                    {_.get(process.env, "REACT_APP_REPORT_HIDE", "false") === "false" && (
                      <Row>
                        <Col xs={12} sm={12} style={{minHeight: "550px"}}>
                        {loading && (
                          <Alert variant="info" className="p-3">
                            <p className="loading-msg">Fetching Reports</p>
                            <ProgressBar variant="info" animated now={100} />
                          </Alert>
                        )}
                        {!loading && <>
                        <div className="nav nav-pills nav-fill my-3 p-1 rounded-3" style={{ background: "#F1F5F9", border: "1.5px solid #94A3B8" }}>
                          <button
                            type="button"
                            className={`nav-link py-2 fw-bold ${!listData.show ? "active shadow-sm" : "text-secondary"}`}
                            style={{
                              fontSize: "15px",
                              borderRadius: "8px",
                              background: !listData.show ? "#007AFF" : "transparent",
                              color: !listData.show ? "#FFFFFF" : "#475569"
                            }}
                            onClick={() => reportList(false)}
                          >
                            📊 Graphical Stats Overview
                          </button>
                          <button
                            type="button"
                            className={`nav-link py-2 fw-bold ${listData.show ? "active shadow-sm" : "text-secondary"}`}
                            style={{
                              fontSize: "15px",
                              borderRadius: "8px",
                              background: listData.show ? "#007AFF" : "transparent",
                              color: listData.show ? "#FFFFFF" : "#475569"
                            }}
                            onClick={() => reportList(true)}
                          >
                            📋 Detailed Records List
                          </button>
                        </div>
                          {listData.show === false && !loading && <>
                            {filter.tab === "jobs" && isReportVisible("jobs") && showJobsReport()}
                            {filter.tab === "tasks" && isReportVisible("tasks") && showTasksReport()}
                            {filter.tab === "attendance" && isReportVisible("attendance") && showAttnReport()}
                            {filter.tab === "holidays" && isReportVisible("holidays") && showHolidaysReport()}
                            {isReportVisible() === false && (
                              <Alert variant="warning" className="text-center">
                                <b>No Stats found!</b>
                              </Alert>
                            )}
                          </>}
                          {isReportVisible() && listData.show && <div className="report-listing">{renderReportList()}</div>}
                        </>}
                        </Col>
                      </Row>
                    )}

                    
                    {isReportVisible() && (
                      <Row>
                        <Col xs={12} className="d-flex justify-content-end">
                          <form action="/admin/api/reports/download" method="post" onSubmit={exportReport}>
                            <input type="hidden" name="tab" value={filter.tab} />
                            <input type="hidden" name="jcat" value={filter.jcat} />
                            <input type="hidden" name="user" value={filter.user} />
                            <input type="hidden" name="branch_id" value={filter.branch} />
                            <input type="hidden" name="jobmode" value={filter.jobmode} />
                            <input type="hidden" name="dt_from" value={filter.fromDt} />
                            <input type="hidden" name="dt_to" value={filter.toDt} />
                            {listData.show && <input type="hidden" name="listmode" value={listData.listmode} />}
                            <Button type="submit" variant="primary" className="style1 radius-both shadow-cst p-0 text-light p-2 px-5">
                              Export {_.upperFirst(filter.tab)} {listData.show && <>- {_.upperFirst(listData.label)}</>}
                            </Button>
                          </form>
                        </Col>
                      </Row>
                    )}
                  </Card.Body>
                </Card>
              </Col>
            </Row>
      </div>
    </>
  );
};

export default Reports;
